import { Card, CardBody, Col, Input, Label } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { SwitchWithIcon } from "../../../../Constant";
import { SWITCH_WITH_ICON, SWITCH_WITH_ICON_LIST } from "../../../../Data/FormWidgets";

const SwitchWithIcons = () => {
  return (
    <Col md="12">
      <Card>
        <CommonCardHeader title={SwitchWithIcon} span={SWITCH_WITH_ICON} />
        <CardBody className="common-flex switch-wrapper">
          {SWITCH_WITH_ICON_LIST.map(({ label, flexClass, defaultChecked, disabled }, index) => (
            <div className="d-flex" key={index}>
              <Label className="col-form-label m-r-10" check>
                {label}
              </Label>
              <div className={`flex-grow-1 text-end icon-state ${flexClass}`}>
                <Label className="switch">
                  <Input type="checkbox" defaultChecked={defaultChecked} disabled={disabled} />
                  <span className="switch-state"></span>
                </Label>
              </div>
            </div>
          ))}
        </CardBody>
      </Card>
    </Col>
  )
}

export default SwitchWithIcons